import { memo } from 'react';
import {
  ListBox as RACListBox,
  ListBoxItem as RACListBoxItem,
  ListBoxItemProps as RACListBoxItemProps,
  ListBoxProps as RACListBoxProps,
} from 'react-aria-components';

import { merge } from '@/components';

export type ListBoxProps<T> = RACListBoxProps<T>;
export type ListBoxItemProps<T> = RACListBoxItemProps<T>;

const IListBox = <T extends object>({ className, children, ...rest }: ListBoxProps<T>) => {
  return (
    <RACListBox aria-label="listbox" className={merge('rounded-lg outline-none', className)} {...rest}>
      {children}
    </RACListBox>
  );
};

const IListBoxItem = ({ className, children, ...rest }: ListBoxItemProps) => {
  return (
    <RACListBoxItem
      className={merge(
        'cursor-pointer items-center gap-2 rounded-lg bg-white p-2 outline-none hover:bg-gray-50',
        className
      )}
      {...rest}
    >
      {children}
    </RACListBoxItem>
  );
};

export const ListBox = memo(IListBox) as typeof IListBox;
export const ListBoxItem = memo(IListBoxItem) as typeof IListBoxItem;
